import { functions } from "./firebase/firebaseInit";
import { httpsCallable } from "@firebase/functions";

export const getCallHistory = async (filters, quantity, offset) => {
    const getUserCallHistory = httpsCallable(functions, "getUserCallHistory");
    const result = await getUserCallHistory({ filters, quantity, offset });
    return JSON.parse(result.data) || [];
};
